import axios from "axios";

export default axios.create({
  baseURL: "https://stackops.pre-freshmarketer.io/api",
  headers: {
    "Content-type": "application/json",
  }
});
